import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';

import authMiddleware from 'store/middlewares/auth';
import { reducer as accountReducer } from 'store/modules/account';
import { reducer as accountsReducer } from 'store/modules/accounts';
import { reducer as apiTokensReducer } from 'store/modules/apiTokens';
import { reducer as authReducer, saga as authSaga } from 'store/modules/auth';
import { reducer as contactSupportReducer } from 'store/modules/contactSupport';
import {
  reducer as dashboardReducer,
  saga as dashboardSaga,
} from 'store/modules/dashboard';
import { reducer as oauthReducer } from 'store/modules/oauth';
import { reducer as originsReducer } from 'store/modules/origins';
import { reducer as serviceOptionsReducer } from 'store/modules/serviceOptions';
import { reducer as servicesReducer } from 'store/modules/services';
import { reducer as settingReducer } from 'store/modules/setting';
import { reducer as statsReducer } from 'store/modules/stats';
import { reducer as uiReducer } from 'store/modules/ui';

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, authMiddleware];

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer, // throws non-serializable value error
  setting: settingReducer,
  services: servicesReducer,
  origins: originsReducer,
  apiTokens: apiTokensReducer,
  serviceOptions: serviceOptionsReducer,
  ui: uiReducer,
  account: accountReducer,
  stats: statsReducer,
  accounts: accountsReducer,
  oauth: oauthReducer,
  contactSupport: contactSupportReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(middlewares), // temporariry disable serializableCheck
});

sagaMiddleware.run(function* rootSaga() {
  yield all([authSaga(), dashboardSaga()]);
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
